<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('southkorea.Header') }}</h2>
                <h3>{{ $t('southkorea.FlagHeader') }}</h3>
                <table border="0">
                    <tr>
                        <td>
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="162" height="108" viewBox="-36 -24 72 48">
                                <title>Flag of South Korea</title>
                                <rect fill="#fff" x="-36" y="-24" width="72" height="48" />
                                <g transform="rotate(-56.3099325)">
                                    <!--arctan(-3/2)-->
                                    <g id="b2">
                                        <path id="b" d="M-6-25H6M-6-22H6M-6-19H6" stroke="#000" stroke-width="2" />
                                        <use xlink:href="#b" y="44" />
                                    </g>
                                    <path stroke="#fff" stroke-width="1" d="M0,17v10" />
                                    <circle fill="#cd2e3a" r="12" />
                                    <path fill="#0047a0" d="M0-12A6,6 0 0 0 0,0A6,6 0 0 1 0,12A12,12 0 0,1 0-12Z" />
                                </g>
                                <g transform="rotate(-123.6900675)">
                                    <use xlink:href="#b2" />
                                    <path stroke="#fff" stroke-width="1" d="M0-23.5v3M0,17v3.5M0,23.5v3" />
                                </g>
                            </svg>
                        </td>
                        <td>&nbsp;&nbsp;&nbsp;</td>
                        <td valign="top">
                            <p>
                                {{ $t('southkorea.FlagText1') }}
                            </p>
                            <p>{{ $t('southkorea.FlagText2') }}</p>
                        </td>
                    </tr>
                </table>
                <table border="1" style="border-collapse:collapse">
                    <tr>
                        <td align="center">
                            <strong>{{ $t('southkorea.FlagSkyBold') }} </strong>
                        </td>
                        <td align="center">
                            <strong>{{ $t('southkorea.FlagWaterBold') }} </strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ $t('southkorea.FlagSky') }}
                        </td>
                        <td>
                            {{ $t('southkorea.FlagWater') }}
                        </td>
                    </tr>
                    <tr>
                    </tr>
                    <tr>
                        <td align="center">
                            <strong>{{ $t('southkorea.FlagSunBold') }} </strong>
                        </td>
                        <td align="center">
                            <strong>{{ $t('southkorea.FlagEarthBold') }} </strong>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ $t('southkorea.FlagSun') }}
                        </td>
                        <td>
                            {{ $t('southkorea.FlagEarth') }}
                        </td>
                    </tr>
                </table>
                <br />
                {{ $t('southkorea.FlagBackground') }}
                <br />
                <h3>{{ $t('southkorea.RepublicHeader') }}</h3>
                {{ $t('southkorea.RepublicText') }}
                <br />
            </div>
        </div>
        
        <div id="image_holder" class="imageHolder">
            <img src="../images/dictionary/worldmapsouthkoreawithdetail.png" class="img-fit">
        </div>

        <div class="transbox">
            <div class="transboxContent">
                <h3>{{ $t('southkorea.CurrencyHeader') }}</h3>
                {{ $t('southkorea.CurrencyText') }}
                <br />
                <h3>{{ $t('southkorea.StructureHeader') }}</h3>
                {{ $t('southkorea.StructureText') }}
                <br />
                <h3>{{ $t('southkorea.EconomyHeader') }}</h3>
                {{ $t('southkorea.EconomyText') }}
                <br />
                <h3>{{ $t('southkorea.ReligionHeader') }}</h3>
                {{ $t('southkorea.ReligionText') }}
                <br />
                <h3>{{ $t('southkorea.LanguageHeader') }}</h3>
                {{ $t('southkorea.LanguageText') }}
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>